var ui_templates = require("ui-templates");

var ProcessMessageView = function (model, holder, config) {
    var self =  this;
    this.model = model;
    this.holder = holder;
    this.config = config; 

    // OBSERVERS
    this.model.visible.onChange({}, function(value, old){
        if(value){
            self.getTemplate().show();
        }else{
            self.getTemplate().hide();
        }
    }, 10);

    this.model.message.onChange({}, function(value, old){
        self.getTemplate().setMessage(value);
    }, 10);

};

module.exports = ProcessMessageView;

ProcessMessageView.prototype.getTemplate = function () {
    if(!this._template){
        this._template = new ui_templates.Processing({
            target: this.holder
        });
    }
    return this._template;
};